<template>
  <div>
    <b-sidebar
      id="sidebar-backdrop"
      backdrop
      width="383px"
      bg-variant="bgcontainer"
      body-class="scroll-bar"
      no-header
      :visible="visible"
      @change="visibleChange"
    >
      <div class="header">
        <i
          class="icon-Circle-X text-40 text-primary cursor-pointer position-absolute"
          @click="onClickClose"
        ></i>
      </div>
      <MoreContent @click="onClickEvent" />
    </b-sidebar>
  </div>
</template>

<script>
import BackEvent from '@/lib/base/backEvent.js';
import MoreContent from '@/components/More/MoreContent.vue';

export default {
  components: {
    MoreContent,
  },
  computed: {
    visible() {
      return this.$store.state.env.isSidebarShow;
    },
  },
  methods: {
    async onClickEvent(tab) {
      this.$firebase.selectContent('navigation', tab.name);
      this.closeSidebar();
    },
    closeSidebar() {
      this.$store.commit('env/setIsSidebarShow', false);
    },
    visibleChange(visible) {
      this.$store.commit('env/setIsSidebarShow', visible);
      if (!visible) {
        BackEvent.popEvent();
      }
    },
    onClickClose() {
      this.$store.commit('env/setIsSidebarShow', false);
      BackEvent.popEvent();
    },
  },
};
</script>

<style lang="scss" scoped>
:deep() .b-sidebar-backdrop {
  background: $grayscale-50 !important;
  height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  height: calc(100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  margin-top: env(safe-area-inset-top);
}
:deep() .b-sidebar {
  padding: env(safe-area-inset-top) 0 env(safe-area-inset-bottom) 0;
  left: 120px;
  &:not(.b-sidebar-right) {
    left: 120px;
  }
}
:deep() .b-sidebar-body {
  overflow: overlay;
}

.header {
  height: 56px;
  width: 100%;
  position: relative;
  .icon-Circle-X {
    right: 16px;
    top: 16px;
  }
}
</style>
